let accounting = require("accounting");

let accountingSettings = {
	currency: {
		symbol : "$",   // default currency symbol is '$'
		format: "%s%v", // controls output: %s = symbol, %v = value/number (can be object: see below)
		decimal : ".",  // decimal point separator
		thousand: ",",  // thousands separator
		precision : 2   // decimal places
	},
	number: {
		precision : 0,  // default precision on numbers is 0
		thousand: ",",
		decimal : "."
	}
}

export const getAccounting = function(settings){
  accounting.settings = accountingSettings;
  if( settings )
    accounting.settings = settings;

  return accounting;
}

export const getSelectOptions = function(obj, options)
{
  let arrayValues = [];
  if(obj != null && obj != ''){
    options.forEach(function(option){ 
      if(obj == option.code+"")
        arrayValues.push({'name':option.name, 'code':option.code, 'status':option.status});
    });
  }
  return arrayValues;  
}

export const getSelectOptionsOnLoad = function(obj, options)
{
  let arrayValues = [];
  if(obj != null && obj != ''){
    options.forEach(function(option){ 
      if(obj.clave == option.code+"")
        arrayValues.push({'name':option.name, 'code':option.code, 'status':option.status});
    });
  }
  return arrayValues;  
}



// WEBPACK FOOTER //
// ./src/helpers/form-common.js